import styled from "styled-components";
import { Wrapper } from "AppReact";
import device from 'utils/device';

const template = styled.div`
  background: ${`${window?.settings?.primary_color ?? '#1DBD6B'}0D`};
  border-radius: 0px 0px 85px 85px;
  width: 110px;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
      width: 55px;
      height: 55px;
    }

  @media ${device.tablet} {
    width: 160px;
    height: 155px;
    svg {
      width: 85px;
      height: 85px;
    }
  }
`;

export default Wrapper(template)
